import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Eazy Clothes — komunikat dostepnosci reagujacy na zmiane rozmiaru.
 *
 * Nie liczy tu niczego. Variant-picker Savor przy zmianie wariantu
 * pobiera cala sekcje pod adresem nowego wariantu i rozglasza
 * variant:update z gotowym dokumentem w event.detail.data.html. My
 * wyjmujemy z niego swojego blizniaka i podmieniamy dzieci — cala regula
 * stanu zostaje w snippecie eazy-availability, po stronie Liquida.
 *
 * Uklad przejety z assets/product-inventory.js, zeby zachowywac sie
 * dokladnie tak jak reszta bloków Savor przy tym samym zdarzeniu.
 */
class EazyAvailabilityNote extends HTMLElement {
  connectedCallback() {
    this.#section()?.addEventListener(ThemeEvents.variantUpdate, this.#update);
  }

  disconnectedCallback() {
    this.#section()?.removeEventListener(ThemeEvents.variantUpdate, this.#update);
  }

  #section() {
    return this.closest('.shopify-section, dialog');
  }

  /**
   * @param {CustomEvent} event — variant:update z variant-picker.
   */
  #update = (event) => {
    // Na karcie produktu moze stac wiecej niz jeden produkt (polecane,
    // szybki podglad). Reagujemy tylko na swoj wlasny.
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const incoming = event.detail.data.html.querySelector('eazy-availability-note');
    if (!incoming) return;

    morph(this, incoming, { childrenOnly: true });
  };
}

if (!customElements.get('eazy-availability-note')) {
  customElements.define('eazy-availability-note', EazyAvailabilityNote);
}
